import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { filesActionCreators } from '..';
import { processMessages } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';
import * as api from '../filesApi';

function* renameFileSaga(action: ReturnType<typeof filesActionCreators.renameFile>) {
  yield put(uiActionCreators.showSpinnerDialog());

  try {
    const response = yield* call(api.renameFile, action.payload);

    if (response.value) {
      yield put(filesActionCreators.setFiles(response.value.newFiles));
      yield put(filesActionCreators.processFileRenameActions(response.value.actions));
    }

    yield processMessages(response);
  } catch {
    //
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchRenameFile() {
  yield takeEvery(filesActionCreators.renameFile.match, renameFileSaga);
}
